"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _departmentFilter = require("@ys/crm-common/dist/utils/departmentFilter");
var _tree = require("@ys/utils/lib/tree");
var _vuex = require("vuex");
var _default = exports.default = {
  props: {
    value: {
      type: String,
      default: undefined
    },
    departmentTree: {
      type: Array,
      default: () => []
    },
    currentDepartment: {
      type: Object,
      default: undefined
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    permissionCheck: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      Translate: _departmentFilter.Translate,
      breadcrumb: []
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['roleList']),
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    currentDepartmentList() {
      if (!this.currentDepartmentModel) {
        return this.departmentTree ?? [];
      }
      return this.currentDepartmentModel?.children ?? [];
    },
    departmentBreadcrumb() {
      return (0, _tree.findPath)(this.departmentTree, node => node.id === this.currentDepartmentModel.id);
    },
    currentDepartmentModel: {
      get() {
        return this.currentDepartment;
      },
      set(value) {
        this.$emit('update:current-department', value);
      }
    }
  },
  created() {
    const hasManagerRole = this.roleList.some(role => [_departmentFilter.Translate.Manager, _departmentFilter.Translate.Normal].includes(role.translate));
    if (hasManagerRole) {
      (0, _tree.findNode)(this.departmentTree, node => {
        if ([_departmentFilter.Translate.Manager, _departmentFilter.Translate.Normal].includes(node.translate)) {
          this.currentDepartmentModel = node;
          return true;
        }
        return false;
      });
    } else {
      this.currentDepartmentModel = this.findFirstLeafDepartment(this.departmentTree[0]);
    }
  },
  methods: {
    findFirstLeafDepartment(node) {
      if (!node.children?.length) {
        return node;
      }
      return this.findFirstLeafDepartment(node.children[0]);
    },
    handleDepartmentClick(department) {
      this.currentDepartmentModel = department;
    },
    handleChange(e) {
      this.$emit('change', {
        value: e.target.value,
        option: (0, _tree.findNode)(this.departmentTree, node => {
          return node.id === e.target.value;
        })
      });
    },
    canDepartmentSelect(department) {
      if (!this.permissionCheck) {
        return true;
      }
      return department.translate === _departmentFilter.Translate.Manager;
    }
  }
};